<template>
    <div>
        <div class="recommendPage">
            <swiper :options="swiperOption" ref="mySwiper" @swiper="swiperEvent" @slideChange="slideChangeEvent" @reachEnd="reachEndEvent">
                <swiper-slide>
                    <div class="swiper1">
                        <el-row class="title" :class="{animated: swiper1, bounceIn: swiper1, hidden: !swiper1}">
                            <el-col align="center">
                                <span>言必信</span>
                                <span style="margin-left: 10px">行必果</span>
                            </el-col>
                        </el-row>
                        <video class="video" autoplay muted loop poster="../../assets/images/movie-image.png">
                            <source src="https://oss.xingguo56.com/tms-cmltj/app/movie.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=admin%2F20240420%2F%2Fs3%2Faws4_request&X-Amz-Date=20240420T085441Z&X-Amz-Expires=432000&X-Amz-SignedHeaders=host&X-Amz-Signature=b4d731e8d8525afd879d3a345348109da833365e535c3855e47b104c2e6de9c5" type="video/mp4">
                        </video>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="swiper2">
                        <div class="about-title">关于中创远泰</div>
                        <el-row align="middle" class="about-box">
                            <el-col :span="8" class="about-item-left" :class="{animated: swiper2, bounceInLeft: swiper2, hidden: !swiper2}">
                                <div class="about-left">
                                    <div class="about-left-title">公司简介</div>
                                    <div class="about-left-text">
                                        天津中创远泰物流有限公司于2020年8月13日成立，注册于天津东疆保税港区，是中创物流股份有限公司全资子公司。
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="16" class="about-item-right">
                                <div class="about-right-top" :class="{animated: swiper2, bounceInRight: swiper2, hidden: !swiper2}">
                                    <div class="about-right-top-title">全面物流网络覆盖</div>
                                    <div class="about-left-text">
                                        依托中创物流网络覆盖，以集装箱业务为基础，利用信息化技术，减少中间环节，简化操作流程，实现货主、场站、码头、司机直联，确保物流节点更加透明，运输更加安全高效。
                                    </div>
                                </div>
                                <div class="about-right-bottom" :class="{animated: swiper2, bounceInRight: swiper2, hidden: !swiper2}">
                                    <div class="about-right-bottom-title">优质领先技术平台</div>
                                    <div class="about-left-text">
                                        运用先进的区块链、大数据、云计算等技术，通过独有算法，高效调度运力，以全新网络货运经营模式，提高进出口匹配度，减少空驶，有效利用运力资源，缔造优质陆运服务平台。
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="swiper3">
                        <div class="content">
                            <div class="swiper3-title">
                                <div class="title">网络布局</div>
                                <div class="text">已在天津、青岛建立口岸，辐射山东、江苏、天津、北京、河北、内蒙、河南、山西、陕西等区域</div>
                            </div>
                            <div ref="myEchart" class="personnel"></div>
                            <div class="vehicle-box">
                                <div class="vehicle">
                                    <div class="title">
                                        <mark-count-to ref="vehicle1" color="#fff" separator="," :start-val="0" :end-val="model.vehicles" :duration="3000"></mark-count-to>
                                    </div>
                                    <div class="text">注册车辆</div>
                                </div>
                                <div class="vehicle">
                                    <div class="title">
                                        <mark-count-to ref="vehicle2" color="#fff" separator="," :start-val="0" :end-val="model.mileage" :duration="3000"></mark-count-to>
                                        <span class="text">公里</span>
                                    </div>
                                    <div class="text">运输总里程</div>
                                </div>
                                <div class="vehicle">
                                    <div class="title">
                                        <mark-count-to ref="vehicle3" color="#fff" separator="," :start-val="0" :end-val="model.driver" :duration="3000"></mark-count-to>
                                    </div>
                                    <div class="text">活跃司机</div>
                                </div>
                            </div>
                            <!--弹窗-->
                            <!--<div class="layer" ref="layer" >
                                <div class="content">
                                    <p>LPL夏季赛(name)</p>
                                    <el-row style="text-align: center;line-height: 22px;height: 24px;">
                                        <Button style="margin-left:4px" type="warning" size="small">item.name</Button>
                                    </el-row>
                                    <el-row style="text-align: center;padding-bottom: 20px;">
                                        <el-col :span="8" class="col-item">
                                            <div class="num">item.circle</div>
                                            <div class="text">item.text</div>
                                        </el-col>
                                    </el-row>
                                    <Spin fix style="background: rgba(0,0,0,0.5);font-size: 20px;">
                                        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                                        <div>Loading</div>
                                    </Spin>
                                </div>
                            </div>-->
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide v-if="newsList1.length > 0 || newsList2.length > 0 || newsList3.length > 0">
                    <div class="swiper4">
                        <div class="news-title">新闻动态</div>
                        <el-row style="width: 1200px;margin: auto" :gutter="30">
                            <el-col :span="8" align="left" :class="{animated: swiper4, bounceInLeft: swiper4, hidden: !swiper4}" v-if="newsList1.length > 0">
                                <div class="title">最新活动 <router-link class="link" :to="{name:'News', params: {active: '1452512989129256961'}}">查看更多<i class="el-icon-d-arrow-right"></i></router-link></div>
                                <div class="text-box">
                                    <el-row class="text" v-for="(item, index) in newsList1" :key="index">
                                        <div @click="skipLink(item.id)" style="cursor:pointer;">
                                            <el-col :span="16" style=" overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis;">{{item.title}}</el-col>
                                            <el-col :span="8" align="right">{{item.createTime ? item.createTime.substring(0,10) : ''}}</el-col>
                                        </div>
                                    </el-row>
                                </div>
                                <!--<div class="title">最新活动</div>
                                <div class="img-box">
                                    <img class="img" src="../../assets/images/banner-1.png"/>
                                </div>
                                <div class="img-box">
                                    <img class="img" src="../../assets/images/banner-1.png"/>
                                </div>-->
                            </el-col>
                            <el-col :span="8" align="left" :class="{animated: swiper4, bounceInRight: swiper4, hidden: !swiper4}" style="animation-delay: 0.1s;"  v-if="newsList2.length > 0">
                                <div class="title">行果新闻 <router-link class="link" :to="{name:'News', params: {active: '1452513187419172865'}}">查看更多<i class="el-icon-d-arrow-right"></i></router-link></div>
                                <div class="text-box">
                                    <el-row class="text" v-for="(item, index) in newsList2" :key="index">
                                        <div @click="skipLink(item.id)" style="cursor:pointer;">
                                            <el-col :span="16" style="overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis;">{{item.title}}</el-col>
                                            <el-col :span="8" align="right">{{item.createTime ? item.createTime.substring(0,10) : ''}}</el-col>
                                        </div>
                                    </el-row>
                                </div>
                            </el-col>
                            <el-col :span="8" align="left" :class="{animated: swiper4, bounceInRight: swiper4, hidden: !swiper4}" style="animation-delay: 0.3s;" v-if="newsList3.length > 0">
                                <div class="title">行业动态 <router-link class="link" :to="{name:'News', params: {active: '1452513366746640385'}}">查看更多<i class="el-icon-d-arrow-right"></i></router-link></div>
                                <div class="text-box">
                                    <el-row class="text" v-for="(item, index) in newsList3" :key="index">
                                        <div @click="skipLink(item.id)" style="cursor:pointer;">
                                            <el-col :span="16" style=" overflow:hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow:ellipsis;">{{item.title}}</el-col>
                                            <el-col :span="8" align="right">{{item.createTime ? item.createTime.substring(0,10) : ''}}</el-col>
                                        </div>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="swiper5">
                        <div style="width: 1200px;margin: auto">
                            <div class="news-title">数据支持</div>
                            <div class="news-text">可靠的数据支持，全方位保障您的业务实践</div>
                            <el-row class="news">
                                <el-col :span="6" align="left">
                                    <div class="number">
                                        <mark-count-to ref="number1" color="#fff" separator="," :start-val="0" :end-val="model.station" :duration="3000"></mark-count-to>
                                        <span class="text">个</span>
                                    </div>
                                    <div class="text">承运总站点</div>
                                </el-col>
                                <el-col :span="6" align="left">
                                    <div class="number">
                                        <mark-count-to ref="number2" color="#fff" separator="," :start-val="0" :end-val="model.container" :duration="3000"></mark-count-to>
                                        <span class="text">TEU</span>
                                    </div>
                                    <div class="text">承运总箱量</div>
                                </el-col>
                                <el-col :span="6" align="left">
                                    <div class="number">
                                        <mark-count-to ref="number3" color="#fff" separator="," :start-val="0" :end-val="model.order" :duration="3000"></mark-count-to>
                                        <span class="text">单</span>
                                    </div>
                                    <div class="text">承运总订单数</div>
                                </el-col>
                                <el-col :span="6" align="left">
                                    <div class="number">
                                        <mark-count-to ref="number4" color="#fff" separator="," :start-val="0" :end-val="model.train" :duration="3000"></mark-count-to>
                                        <span class="text">车</span>
                                    </div>
                                    <div class="text">承运总车次</div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="swiper6">
                        <div style="width: 1200px;margin: auto">
                            <div class="downloads-title">产品下载</div>
                            <el-row style="margin-top: 70px;">
                                <el-col :span="12" style="position: relative;height: 60vh;" align="center">
                                    <img class="img1" :class="{animated: swiper6, bounceInLeft: swiper6, hidden: !swiper6}" src="../../assets/images/app1.png">
                                    <img class="img2" :class="{animated: swiper6, bounceInLeft: swiper6, hidden: !swiper6}" src="../../assets/images/app2.png">
                                </el-col>
                                <el-col :span="12">
                                    <el-row :class="{animated: swiper6, bounceInRight: swiper6, hidden: !swiper6}" style="margin-top: 80px;">
                                        <el-col :span="10">
                                            <img class="img3" src="../../assets/images/weixin.jpg">
                                        </el-col>
                                        <el-col :span="14" align="left" style="line-height: 150px;">
                                            扫描关注行果公众号
                                        </el-col>
                                    </el-row>
                                    <el-row :class="{animated: swiper6, bounceInRight: swiper6, hidden: !swiper6}" style="animation-delay: 0.2s;margin-top: 20px;">
                                        <el-col :span="10">
                                            <img class="img3" src="../../assets/images/qrcode.png">
                                        </el-col>
                                        <el-col :span="14" align="left" style="line-height: 150px;">
                                            扫描下载行果APP
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide style="height: auto;">
                    <div class="swiper7">
                        <div class="consult-box">
                            <div class="consult">
                                <el-row type="flex" align="bottom">
                                    <el-col :span="12" style="height: 200px;">
                                        <div class="title">我们可以为您提供哪些帮助?</div>
                                        <div class="text">电话：400-606-5656</div>
                                        <div class="text">地址：天津自贸试验区（东疆保税港区）宁夏道1133号</div>
                                        <div class="text"><el-button style="color: #34ba8d;margin-top: 10px;" @click="veniceEvent">立即咨询</el-button></div>
                                    </el-col>
                                    <el-col :span="12">
                                        <img class="img" src="../../assets/images/consult.png">
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        <div class="footer-box">
                            <div class="footer">
                                <el-row :gutter="50" type="flex" justify="end" style="padding-bottom: 30px;">
                                    <el-col :span="6">
                                        <div class="title">新闻动态</div>
                                        <div class="text" v-for="(item, index) in categoryList" :key="index">
                                            <router-link :to="{name:'News', params: {active: item.id}}">{{item.name}}</router-link>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="title">咨询投诉</div>
                                        <div class="text">
                                            <router-link :to="{name:'Publicity', params: {}}">咨询投诉公示</router-link>
                                        </div>
                                        <div class="text">
                                            <router-link :to="{name:'Consult', params: {active: 2}}">咨询投诉机制</router-link>
                                        </div>
                                        <div class="text">
                                            <router-link :to="{name:'Consult', params: {active: 3}}">我要咨询</router-link>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="title">评价公示</div>
                                        <div class="text">
                                            <router-link :to="{name:'Appraise', params: {active: 1}}">承运人评价</router-link>
                                        </div>
                                        <div class="text">
                                            <router-link :to="{name:'Appraise', params: {active: 2}}">托运人评价</router-link>
                                        </div>
                                        <div class="text">
                                            <router-link :to="{name:'Appraise', params: {active: 3}}">评价机制</router-link>
                                        </div>
                                        <div class="text">
                                            <router-link :to="{name:'Appraise', params: {active: 4}}">退出机制</router-link>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="title">关于我们</div>
                                        <div class="text">
                                            <router-link :to="{name:'About', params: {}}">关于我们</router-link>
                                        </div>
                                        <div class="text">
                                            <router-link :to="{name:'About', params: {}}">联系我们</router-link>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="50" style="padding: 0 25px">
                                    <el-col style="line-height: 90px;color: #949aab;vertical-align: middle;border-top: 1px solid #949aab;font-size: 12px;">
                                        &copy; 2020-2024 天津中创远泰物流有限公司
                                        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12019302000123" style="vertical-align: middle;display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                                            <img src="~@/assets/icon-report.png" style="float:left;"/>
                                            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#949aab;">
                                                津公网安备 12019302000123号
                                            </p>
                                        </a>
                                        <a target="_blank" href="https://beian.miit.gov.cn" style="vertical-align: middle;display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                                            <p style="height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#949aab;">
                                                津ICP备2020007907号-1
                                            </p>
                                        </a>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <!--                <div class="swiper-button-prev" slot="button-prev"></div>-->
                <!--                <div class="swiper-button-next" slot="button-next"></div>-->
            </swiper>
        </div>
    </div>
</template>

<script>
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.min.css'
import 'swiper-animate/animate.min.css'
import { getHomeLayout, getHomeCarrier, getNewsList, getCategoryList } from '@/api/api'
import markCountTo from '@/components/mark-count-to/mark-count-to'

let geoCoordMap = {
    '黑龙江': [127.9688, 45.368],
    '内蒙古': [110.3467, 41.4899],
    '吉林': [125.8154, 44.2584],
    '北京市': [116.4551, 40.2539],
    '辽宁': [123.1238, 42.1216],
    '河北': [114.4995, 38.1006],
    '天津': [117.4219, 39.4189],
    '山西': [112.3352, 37.9413],
    '陕西': [109.1162, 34.2004],
    '甘肃': [103.5901, 36.3043],
    '宁夏': [106.3586, 38.1775],
    '青海': [101.4038, 36.8207],
    '新疆': [87.9236, 43.5883],
    '西藏': [91.11, 29.97],
    '四川': [103.9526, 30.7617],
    '重庆': [108.384366, 30.439702],
    '山东': [117.1582, 36.8701],
    '河南': [113.4668, 34.6234],
    '江苏': [118.8062, 31.9208],
    '安徽': [117.29, 32.0581],
    '湖北': [114.3896, 30.6628],
    '浙江': [119.5313, 29.8773],
    '福建': [119.4543, 25.9222],
    '江西': [116.0046, 28.6633],
    '湖南': [113.0823, 28.2568],
    '贵州': [106.6992, 26.7682],
    '云南': [102.9199, 25.4663],
    '广东': [113.12244, 23.009505],
    '广西': [108.479, 23.1152],
    '海南': [110.3893, 19.8516],
    '上海': [121.4648, 31.2891],
    '青岛': [120.386673, 36.081391]
}
let chinaDatas = []

export default {
    name: 'Home',
    components: {
        swiper,
        swiperSlide,
        markCountTo
    },
    data () {
        let that = this
        return {
            swiper1: true,
            swiper2: false,
            swiper3: false,
            swiper4: false,
            swiper5: false,
            swiper6: false,
            swiperOption: {
                loop: false,
                direction: 'vertical',
                slidesPerView: 'auto',
                // autoplay: {
                //     delay: 3000,
                //     stopOnLastSlide: false,
                //     disableOnInteraction: false
                // },
                // 显示分页
                mousewheel: {
                    releaseOnEdges: true
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true // 允许分页点击跳转
                },
                on: {
                    slideChangeTransitionStart: function () {
                        // that.$refs.vehicle1.reset()
                        // that.$refs.vehicle2.reset()
                        // that.$refs.vehicle3.reset()
                        // that.$refs.number1.reset()
                        // that.$refs.number2.reset()
                        // that.$refs.number3.reset()
                        // that.$refs.number4.reset()
                        if (that.swiper.activeIndex === 1) {
                            that.swiper2 = false
                            that.$emit('containerChange', true)
                        } else if (that.swiper.activeIndex === 2) {
                            that.swiper3 = false
                            that.$emit('containerChange', true)
                        } else if (that.swiper.activeIndex === 3) {
                            that.swiper4 = false
                            that.$emit('containerChange', true)
                        } else if (that.swiper.activeIndex === 4) {
                            that.swiper5 = false
                            that.$emit('containerChange', true)
                        } else if (that.swiper.activeIndex === 5) {
                            that.swiper6 = false
                            that.$emit('containerChange', true)
                        } else {
                            that.swiper1 = false
                            that.$emit('containerChange', false)
                        }
                    },
                    slideChangeTransitionEnd: function () {
                        if (that.swiper.activeIndex === 1) {
                            that.swiper2 = true
                        } else if (that.swiper.activeIndex === 2) {
                            that.swiper3 = true
                            that.$refs.vehicle1.start()
                            that.$refs.vehicle2.start()
                            that.$refs.vehicle3.start()
                        } else if (that.swiper.activeIndex === 3) {
                            if (!that.newsList1.length > 0 && !that.newsList2.length > 0 && !that.newsList3.length > 0) {
                                that.swiper5 = true
                                that.$refs.number1.start()
                                that.$refs.number2.start()
                                that.$refs.number3.start()
                                that.$refs.number4.start()
                            } else {
                                that.swiper4 = true
                            }
                        } else if (that.swiper.activeIndex === 4) {
                            if (!that.newsList1.length > 0 && !that.newsList2.length > 0 && !that.newsList3.length > 0) {
                                that.swiper6 = true
                            } else {
                                that.swiper5 = true
                                that.$refs.number1.start()
                                that.$refs.number2.start()
                                that.$refs.number3.start()
                                that.$refs.number4.start()
                            }
                        } else if (that.swiper.activeIndex === 5) {
                            that.swiper6 = true
                        } else {
                            that.swiper1 = true
                        }
                    }
                }
            },
            option: {},
            model: [],
            newsList1: [],
            newsList2: [],
            newsList3: [],
            categoryList: []
        }
    },
    computed: {
        swiper () {
            return this.$refs.mySwiper.swiper
        }
    },
    created () {
        getCategoryList({categoryCode: 'XGXWDT-1'}).then(res => {
            if (res.data.success) {
                this.categoryList = res.data.result
            }
        })
        getHomeLayout().then(res => {
            let result = res.data.result
            if (res.data.success && result) {
                this.model.vehicles = result.registeredVehicles
                this.model.mileage = result.totalMileage
                this.model.driver = result.onlineDriver
                chinaDatas = []
                for (let item in result.cityVehicles) {
                    chinaDatas.push([{
                        name: item,
                        value: result.cityVehicles[item]
                    }])
                }
                this.$nextTick(() => {
                    this.getMap3d()
                })
            }
        })
        getHomeCarrier().then(res => {
            let result = res.data.result
            if (res.data.success && result) {
                this.model.station = result.stationNum
                this.model.container = result.totalContainer
                this.model.order = result.totalOrder
                this.model.train = result.totalTrainNum
            }
        })
        /* 最新活动 */
        getNewsList({categoryId: '1452512989129256961', pageSize: 10}).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
                let result = res.data.result
                this.newsList1 = result.records
            }
        })
        /* 行果新闻 */
        getNewsList({categoryId: '1452513187419172865', pageSize: 10}).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
                let result = res.data.result
                this.newsList2 = result.records
            }
        })
        /* 行业动态 */
        getNewsList({categoryId: '1452513366746640385', pageSize: 10}).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
                let result = res.data.result
                this.newsList3 = result.records
            }
        })
    },
    mounted () {
        // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
        // console.log(this.swiper)
        // this.swiper.slideTo(3, 1000, false);
    },
    methods: {
        skipLink (id) {
            console.log(id)
            this.$router.push({path: '/news-details', query: {id: id}})
        },
        convertData (data) {
            let res = []
            for (let i = 0; i < data.length; i++) {
                let geoCoord = geoCoordMap[data[i][0].name]
                if (geoCoord) {
                    res.push({
                        name: data[i][0].name,
                        value: geoCoord.concat(data[i][0].value)
                    })
                }
            }
            return res
        },
        /**
         * 加载3D地图
         */
        getMap3d () {
            this.$nextTick(() => {
                this.myChart = this.$echarts.init(this.$refs.myEchart)
                this.option = {
                    tooltip: {
                        show: true,
                        formatter: function (params) {
                            let name = params.name
                            let value = params.value[2]
                            let mark = params.marker
                            let text = `${name}<br/>${mark}车辆：${value}`
                            return text
                        }
                    },
                    geo: {
                        data: this.convertData(chinaDatas),
                        map: 'china',
                        color: '#fff',
                        geoIndex: 0,
                        roam: false, // 是否开启鼠标缩放和平移漫游。默认不开启。
                        itemStyle: {
                            normal: {
                                // areaColor: '#031525',
                                // borderColor: '#FFFFFF'
                                borderColor: 'rgba(147, 235, 248, 1)',
                                borderWidth: 1,
                                areaColor: {
                                    type: 'radial',
                                    x: 0.5,
                                    y: 0.5,
                                    r: 0.8,
                                    colorStops: [
                                        {
                                            offset: 0,
                                            color: 'rgba(147, 235, 248, 0)' // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(147, 235, 248, .2)' // 100% 处的颜色
                                        }
                                    ],
                                    globalCoord: false // 缺省为 false
                                },
                                shadowColor: 'rgba(128, 217, 248, 1)'
                            },
                            emphasis: {
                                areaColor: '#2B91B7'
                            }
                        },
                        viewControl: {
                            distance: 90, // 地图视角 控制初始大小
                            rotateSensitivity: 0, // 禁止旋转
                            zoomSensitivity: 0 // 禁止缩放
                        },
                        label: {
                            normal: {
                                show: true,
                                color: '#fff'
                            },
                            emphasis: {
                                show: true,
                                textStyle: {
                                    color: '#fff'
                                }
                            }
                        },
                        emphasis: { // 当鼠标放上去的状态
                            label: {
                                show: true
                            },
                            itemStyle: {
                                // color: '#000'
                            }
                        },
                        formatter: val => {
                            return val
                        },
                        legendHoverLink: true
                    },
                    series: [
                        {
                            name: '车辆',
                            tooltip: {
                                show: true
                            },
                            type: 'effectScatter',
                            coordinateSystem: 'geo',
                            rippleEffect: {
                                scale: 10,
                                brushType: 'stroke'
                            },
                            showEffectOn: 'render',
                            itemStyle: {
                                normal: {
                                    color: '#00FFFF'
                                }
                            },
                            label: {
                                normal: {
                                    color: '#fff'
                                }
                            },
                            symbol: 'circle',
                            symbolSize: [10, 5],
                            data: this.convertData(chinaDatas),
                            zlevel: 1
                        },
                        {
                            name: '车辆',
                            type: 'scatter', // 标识点
                            coordinateSystem: 'geo',
                            itemStyle: {
                                color: '#00FFF6'
                            },
                            symbol: 'image://data:image/png;base64,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',
                            symbolSize: [32, 41],
                            symbolOffset: [0, -20],
                            data: this.convertData(chinaDatas),
                            z: 999
                        }
                    ]
                }
                this.myChart.setOption(this.option)
            })
        },
        swiperEvent (a, b, c) {
            // console.log('swiperEvent', a, b, c)
        },
        slideChangeEvent (a, b, c) {
            // console.log('slideChangeEvent', a, b, c)
        },
        reachEndEvent (a, b, c) {
            // console.log('reachEndEvent', a, b, c)
        },
        veniceEvent () {
            this.$router.push({name: 'Consult', params: {key: '3'}})
        }
    }
}
</script>

<style scoped>
.swiper-container {
    height: 100vh;
}
.hidden{
    display: none;
}

</style>
<style lang='scss' scoped>
.swiper1 {
    height: 100%;
    /*background-image: url('../../assets/images/banner-1.png');
    background-size: cover;*/
    .title{
        width: 100%;
        position: absolute;
        top: 70%;
        font-size: 60px;
        font-weight: bold;
        color: #ffffff;
        animation-delay: 0.5s;
    }
    .video{
        z-index: 1;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
        -o-object-position: 50% 50%;
        object-position: 50% 50%;
        vertical-align: middle;
        width: 100%;
    }
}
.swiper2{
    .el-row{
        height: 100vh;
    }
    .el-col{
        height: 100vh;
    }
    .about-title {
        text-align: center;
        font-size: 30px;
        color: #1c1e41;
        margin-top: 130px;
    }
    .about-box{
        .about-item-left{
            text-align: right;
            .about-left{
                margin-top: 10%;
                margin-right: 4%;
                height: 48%;
                width: 50%;
                background-image: url("../../assets/images/about-1.png");
                background-size: cover;
                display: inline-block;
                padding: 25px;
                text-align: left;
                .about-left-title{
                    font-size: 24px;
                    color: #fff;
                    height: 60px;
                    line-height: 60px;
                    border-bottom: 1px solid #9995e8;
                }
                .about-left-text{
                    margin-top: 15px;
                    line-height: 40px;
                    color: #ffffff;
                    font-size: 14px;
                }
            }
        }
        .about-item-right{
            text-align: left;
            .about-right-top{
                margin-top: 5%;
                height: 20%;
                width: 75%;
                background-image: url("../../assets/images/about-2.png");
                background-size: cover;
                padding: 25px;
                text-align: left;
                animation-delay: 0.1s;
                .about-right-top-title{
                    font-size: 24px;
                    color: #fff;
                    height: 60px;
                    line-height: 60px;
                    border-bottom: 1px solid #40c9e3;
                }
                .about-left-text{
                    margin-top: 15px;
                    line-height: 40px;
                    color: #ffffff;
                    font-size: 14px;
                }
            }
            .about-right-bottom{
                margin-top: 2%;
                height: 20%;
                width: 75%;
                background-image: url("../../assets/images/about-3.png");
                background-size: cover;
                padding: 25px;
                text-align: left;
                animation-delay: 0.2s;
                .about-right-bottom-title{
                    font-size: 24px;
                    color: #fff;
                    height: 60px;
                    line-height: 60px;
                    border-bottom: 1px solid #83b4ef;
                }
                .about-left-text{
                    margin-top: 15px;
                    line-height: 40px;
                    color: #ffffff;
                    font-size: 14px;
                }
            }
        }
    }
}
.swiper3{
    height: 100%;
    background-image: url("../../assets/images/banner-2.png");
    background-size: cover;
    .content {
        position: relative;
        .swiper3-title {
            position: absolute;
            top: 14vh;
            left: 50%;
            transform: translateX(-50%);
            font-family: Microsoft YaHei;
            margin: 0;
            .title{
                font-size: 30px;
                line-height: 30px;
                color: #fff;
            }
            .text{
                margin-top: 20px;
                font-size: 16px;
                line-height: 16px;
                color: #fff;
            }
        }
        .personnel {
            width: 80vw;
            height: 80vh;
            position: absolute;
            top: 20vh;
        }
        .vehicle-box{
            position: absolute;
            top: 20vh;
            left: 70vw;
            color: #ffffff;
            .vehicle{
                margin-top: 120px;
                text-align: left;
                .title{
                    font-size: 40px;
                    line-height: 40px;
                    .text{
                        font-size: 16px;
                        line-height: 16px;
                        margin-left: 10px;
                        color: #acb4cc;
                    }
                }
                .text{
                    font-size: 16px;
                    line-height: 16px;
                    margin-top: 18px;
                    color: #acb4cc;
                }
            }
        }
    }
}
.swiper4{
    height: 100%;
    background-image: url("../../assets/images/banner-3.png");
    background-size: cover;
    .news-title{
        text-align: center;
        font-size: 30px;
        color: #1c1e41;
        padding-top: 150px;
    }
    .title{
        margin-top: 50px;
        font-size: 18px;
        color: #1c1e41;
        line-height: 30px;
        .link{
            font-size: 14px;
            color: #acacad;
            float: right;
        }
    }
    .img-box{
        margin-top: 30px;
        display: flex;
        .img{
            width: 100%;
            border-radius: 10px;
        }
    }
    .text-box{
        margin-top: 30px;
        .text{
            font-size: 14px;
            line-height: 48px;
            color: #77788f;
            border-bottom: 1px solid #d3dbe8;
        }
    }

}
.swiper5{
    height: 100%;
    background-image: url("../../assets/images/banner-4.png");
    background-size: cover;
    .news-title{
        text-align: center;
        font-size: 30px;
        line-height: 30px;
        color: #ffffff;
        padding-top: 180px;
    }
    .news-text{
        margin-top: 20px;
        font-size: 16px;
        line-height: 16px;
        color: #fff;
    }
    .news{
        margin-top: 120px;
        .number{
            font-size: 40px;
            line-height: 40px;
            color: #ffffff;
            .text{
                font-size: 16px;
                line-height: 16px;
                margin-left: 10px;
                color: #ffffff;
            }
        }
        .text{
            margin-top: 10px;
            font-size: 16px;
            line-height: 16px;
            color: #adadb5;
        }
    }
}
.swiper6{
    background: #ffffff;
    height: 100vh;
    .downloads-title{
        text-align: center;
        font-size: 30px;
        line-height: 30px;
        color: #000;
        padding-top: 150px;
    }
    .text{
        margin-top: 20px;
        font-size: 16px;
        line-height: 16px;
        color: #fff;
    }
    .img1{
        height: 100%;
        position: absolute;
        top: 0;
        left: 60px;
        z-index: 1;
        animation-delay: 0.2s;
    }
    .img2{
        height: 100%;
        position: absolute;
        top: 28px;
        border: 5px solid #efefef;
        border-radius: 20px;
    }
    .img3{
        width: 150px;
        height: 150px;
        display: block;
        margin: auto;
    }
}
.swiper7{
    height: auto;
    .consult-box{
        background: #34ba8d;
        .consult{
            width: 1200px;
            margin: auto;
            padding-top: 30px;
            .title{
                font-size: 28px;
                color: #ffffff;
                line-height: 60px;
                text-align: left;
            }
            .text{
                font-size: 14px;
                color: #ffffff;
                line-height: 30px;
                text-align: left;
            }
            .img{
                display: block;
                width: 400px;
            }
        }
    }
    .footer-box{
        background: #152147;
        padding-top: 80px;
        .footer{
            width: 1200px;
            height: auto;
            margin: auto;
            .title{
                font-size: 16px;
                color: #ffffff;
                line-height: 60px;
                border-bottom: 1px solid #949aab;
                text-align: left;
                margin-bottom: 10px;
            }
            .text{
                font-size: 12px;
                color: #949aab;
                line-height: 40px;
                text-align: left;
                a{
                    text-decoration: none;
                    outline: none;
                    color: #949aab;
                    &:hover{
                        color: #ffffff;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue